import type { TypographyOptions } from '@mui/material/styles/createTypography';

export const fontFamilyPrimary = 'Poppins, sans-serif';
export const fontFamilySecondary = 'Poppins, sans-serif';

const weight = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700
} as const;

/** Variantes MUI alinhadas à semântica ARIDE. */
export function buildTypographyOptions(textColor: string, textSecondary: string): TypographyOptions {
  return {
    fontFamily: fontFamilyPrimary,
    h1: {
      fontFamily: fontFamilyPrimary,
      fontSize: 48,
      lineHeight: '56px',
      fontWeight: weight.semibold,
      color: textColor
    },
    h2: {
      fontFamily: fontFamilyPrimary,
      fontSize: 40,
      lineHeight: '48px',
      fontWeight: weight.semibold,
      color: textColor
    },
    h3: {
      fontFamily: fontFamilyPrimary,
      fontSize: 32,
      lineHeight: '40px',
      fontWeight: weight.semibold,
      color: textColor
    },
    h4: {
      fontFamily: fontFamilyPrimary,
      fontSize: 28,
      lineHeight: '36px',
      fontWeight: weight.semibold,
      color: textColor
    },
    h5: {
      fontFamily: fontFamilyPrimary,
      fontSize: 24,
      lineHeight: '32px',
      fontWeight: weight.semibold,
      color: textColor
    },
    h6: {
      fontFamily: fontFamilyPrimary,
      fontSize: 20,
      lineHeight: '28px',
      fontWeight: weight.semibold,
      color: textColor
    },
    subtitle1: {
      fontFamily: fontFamilyPrimary,
      fontSize: 18,
      lineHeight: '28px',
      fontWeight: weight.medium,
      color: textColor
    },
    subtitle2: {
      fontFamily: fontFamilyPrimary,
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: weight.medium,
      color: textSecondary
    },
    body1: {
      fontFamily: fontFamilySecondary,
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: weight.regular,
      color: textColor
    },
    body2: {
      fontFamily: fontFamilySecondary,
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: weight.regular,
      color: textSecondary
    },
    button: {
      fontFamily: fontFamilyPrimary,
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: weight.semibold,
      textTransform: 'none'
    },
    caption: {
      fontFamily: fontFamilySecondary,
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: weight.regular,
      color: textSecondary
    },
    overline: {
      fontFamily: fontFamilyPrimary,
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: weight.medium,
      color: textSecondary
    }
  };
}
